import {DateTime} from "luxon";


export default {
    methods:{
        dateFromISOToFormat(_datDate){
            return  DateTime.fromISO(_datDate).toFormat('DD');
        }
    },



}